import { useContext } from 'react';
import { LocalizationContext } from './context';
export function useTranslations() {
    var context = useContext(LocalizationContext);
    return [context.translations, context.locale];
}
//# sourceMappingURL=useTranslations.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ilenia/dist/useTranslations.js
// module id = 700
// module chunks = 0